webpackJsonp([212839066777427],{

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _radium = __webpack_require__(10);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _theme = __webpack_require__(33);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _formatToPath = __webpack_require__(29);
	
	var _formatToPath2 = _interopRequireDefault(_formatToPath);
	
	var _components = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
		base: {
			background: '#fff',
			color: _theme2.default.palette.alternativeTextColor,
			textTransform: 'uppercase'
		},
		boxShadow: {
			background: '#fff',
			paddingTop: '70px',
			boxShadow: 'rgb(66, 66, 66) 0px 100px 100px -100px inset'
		},
		title: {
			textAlign: 'center',
			color: '#3a3a3a',
			fontWeight: 'bold',
			fontSize: '20px'
		},
		img: {
			width: 256,
			height: 116,
			objectFit: 'cover'
		},
		postContainer: {
			padding: '16px 0px',
			overflow: 'hidden',
			height: '64px'
		},
		postTitle: {
			fontWeight: 'bold',
			fontSize: '20px'
		},
		postDate: {
			fontSize: '14px',
			paddingTop: '8px'
		}
	};
	
	var BlogPage = function BlogPage(_ref) {
		var data = _ref.data;
		return _react2.default.createElement(
			'div',
			{ style: styles.base },
			_react2.default.createElement(
				'div',
				{ style: styles.boxShadow },
				_react2.default.createElement(
					'div',
					{ style: styles.title },
					'BLOG'
				)
			),
			_react2.default.createElement(
				_components.ParentBox,
				null,
				data.allContentfulBlogPost.edges.map(function (edge, index) {
					return _react2.default.createElement(
						_components.ChildBox,
						{ key: index },
						_react2.default.createElement('img', { alt: edge.node.title, style: styles.img, src: edge.node.thumbnail.file.url }),
						_react2.default.createElement(
							'div',
							{ style: styles.postContainer },
							_react2.default.createElement(
								'span',
								{ style: styles.postTitle },
								edge.node.title
							),
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								'span',
								{ style: styles.postDate },
								edge.node.publicationDate
							)
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'a',
								{ className: 'link-arrow', href: '/blog/' + (0, _formatToPath2.default)(edge.node.title) },
								'Read More'
							)
						)
					);
				})
			)
		);
	};
	
	exports.default = (0, _radium2.default)(BlogPage);
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = {
		palette: {
			primary1Color: "#080f21",
			primary2Color: "#202637",
			text1Color: "#fff",
			text2Color: "#8b939b",
			text3Color: "#666",
			alternativeTextColor: "#000"
		}
	};
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-d3647a20f388b0a86702.js